export default "__VITE_ASSET__D51YROf2__"